import { useEffect } from "react";
import { replaceNavigation } from "../navigation";
import { workspaceProfilePaths } from "./workspaceProfilePaths";

/** Keep bookmarked preference URLs working; controls now belong to the shared profile. */
export function ProfileLanguageRegionPortal({ path }: { path: string }) {
  useEffect(() => {
    const routes = workspaceProfilePaths(path);
    if (routes && path === routes.languageRegion) replaceNavigation(routes.profile);
  }, [path]);
  return null;
}
